'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var includes = function includes(arr, o) {
    return (0, _isObject2.default)(o) ? JSON.stringify(arr).indexOf(JSON.stringify(o)) > -1 : arr.indexOf(o) > -1;
};
exports.default = includes;
//# sourceMappingURL=includes.js.map